import React, { useContext } from 'react';
import ym from 'react-yandex-metrika';

import { Main, Header, Button } from '@/components';
import { PageContext } from '@/Page';

import styles from './banner.module.scss';

const Banner: React.FC = () => {
  const { handleOpen, setCondition } = useContext(PageContext);

  const handleClick = () => {
    setCondition(2);
    handleOpen();
    ym('reachGoal', 'conditions');
  };

  return (
    <div className={styles.banner}>
      <Header />
      <Main>
        <div className={styles.banner__info}>
          <h1 className={styles.banner__title}>
            Терпите <span className={styles.banner__title_info}>убытки</span>
            <br />
            пока автопарк
            <br /> на ремонте?
          </h1>
          <p className={styles.banner__text}>
            Обслуживайте автопарк день в день без простоев по программе FIT
            FLEET. Узнайте подробности сотрудничества у менеджера
          </p>
          <Button
            className={styles.banner__button}
            variant='primary'
            size='big'
            onClick={handleClick}
          >
            Запросить условия
          </Button>
        </div>
      </Main>
    </div>
  );
};

export default Banner;
